import { css } from '@emotion/css';

export const voiceRecordingElement = css`
	.form-label {
		margin-bottom: 0;
		font-size: 12px;
		color: #757575;
	}

	.form-group {
		margin-bottom: 5px;
	}

	.block {
		margin-top: 35px;
	}
`;
